import { Box, Spinner as ChakraSpinner, SpinnerProps as ChakraSpinnerProps, useColorModeValue } from '@chakra-ui/react';
import PropTypes, { InferProps } from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { getChild } from '_helpers/index';
import { forwardRef } from 'system';

export const sizePropTypes = ['xs', 'sm', 'md', 'lg'];

const defaultProps = {
  size: 'sm',
  color: 'blue.base',
  speed: '1.00s'
};

export const propTypes = {
  size: PropTypes.oneOf(sizePropTypes),
  color: PropTypes.string,
  speed: PropTypes.string
};

type SpinnerProps = ChakraSpinnerProps & InferProps<typeof propTypes>;
const Spinner = forwardRef<SpinnerProps, 'div'>(
  (props: SpinnerProps, ref): React.ReactElement => {
    const { children, ...rest } = props;

    const baseProps = {
      emptyColor: useColorModeValue('silver.base', 'black.lightest'),
      ref
    };

    const text = getChild(DisplayNames.SpinnerText, children);

    return text ? (
      <Box alignItems="center" display="flex" flexDirection="column">
        <ChakraSpinner {...baseProps} {...rest} />
        {text}
      </Box>
    ) : (
      <ChakraSpinner {...baseProps} {...rest} />
    );
  }
);

Spinner.displayName = DisplayNames.Spinner;
Spinner.defaultProps = defaultProps;
Spinner.propTypes = propTypes;

export default Spinner;
export { SpinnerProps };
